import React, { useEffect,useCallback,useState } from "react";
import { Link,useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { hasAccess, instCat, isAdmin, isApprover, isPatient } from "../common/validators";
import moment from "moment";
import BillReminder from "./BillReminder";
import MyDialog from "../components/dialog/Dialog";
import NurseDashboard from "./NurseDashboard";
import AdminDashboard from "./AdminDashboard";
import PatientDashboard from "./PatientDashboard";



const Dashboard = () => {
  const [userMenu, setUserMenu] = useState([]);
  const [seriesData, setSeriesData] = useState([]);
  const [labelsData, setLabelsData] = useState([]);
  const [oPenBillDialog, setOPenBillDialog] = useState(false);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedTheme = useSelector((state) => state.theme.mode);

  

  const handleClickMenu = (url) => {
    //alert(url)
    navigate(url);
  }

  useEffect( async () => {
    if(!localStorage.getItem('token')){
      handleClickMenu('/intro')
    }else{
      
      // dispatch(profitTodayTotalReport({businessDate:moment(businessDate).format("YYYY-MM-DD")}))      
    }
    
  }, [dispatch]);




  

  // useEffect(() => {     
  //   if(!profitTodayError && profitTodayStatus && profitTodayList && profitTodayList.length > 0 && profitTodayList[0]["stock_price"] != null){      
  //     setTotalProfit(profitTodayList[0]["sell_amount"] - profitTodayList[0]["stock_price"])
  //   }else if(!profitTodayError && profitTodayList && profitTodayList.length > 0 && profitTodayList[0]["stock_price"] == null){
  //     setTotalProfit(0)
  //   }
  // },[profitTodayList,profitTodayStatus,profitTodayError])


  // useEffect(()=>{
  //   if(billsList && billsList.length > 0 ){
  //     setOPenBillDialog(true)
  //   }else{
  //     setOPenBillDialog(false)
  //   }

  // },[billsList]);

  const handleCloseBill = () => {
    setOPenBillDialog(false)
  }

  // const dialogOpen = () => {
  //   return <BillReminder billData={oPenBillDialog === true ? billsList[0] : null}/>
  // }

  const handleClick = (toPath=null) => {
    //event.preventDefault();
    if(toPath && toPath != null){
      navigate(toPath); // Redirect to the "props.toPath" route
    }    
  };

  const checkIsAdmin = () => {
      return isAdmin();
  }

  const checkIsApprover = () => {
    return isApprover();
}

const checkIsPatient = () => {
  return isPatient();
}

  return (
    <div>
    
      <div className="ez-main-cards">
        {
          checkIsAdmin() && <AdminDashboard />
        }

        {
          !checkIsAdmin() && !checkIsPatient() && <NurseDashboard />
        }

        {
          checkIsPatient() && <PatientDashboard />
        }
        

       

      </div>
      {/* <MyDialog
        title={"Subscription - Pending Bill"}
        width="md"
        open={oPenBillDialog}
        onClose={()=>handleCloseBill()}
        text={"Subscription - Pending Bill"}
        content={() => dialogOpen()}
        hideSaveButton={true}
        propBackgroundColor="#367588"
      /> */}
    </div>
  );
};

export default Dashboard;
